<template>
  <router-view />
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
}
</style>